import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { UserService } from './../services/user.service';
import { UserType } from './../model/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TeacherAuthGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate = (): Observable<boolean> =>
    this.userService.getCurrentUser()
      .pipe(
        map(u => {
          const isTeacher = !!u && u.userType !== UserType.candidate;
          if (!isTeacher) {
            this.router.navigate(['/login']);
          }
          return isTeacher;
        })
      )
}
